import { assign } from 'xstate';

import { resetDressingQuantity } from '../../helpers';

import type { CustomizationMachineAction } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Resets the dressing portions in the active modifications.
 */
export const resetDressingPortions: CustomizationMachineAction = assign((args) => {
  const { modifications } = args.context;
  const activeModifications = modifications?.active;

  if (!activeModifications) {
    return {};
  }

  return {
    modifications: {
      ...modifications,
      active: activeModifications.map(resetDressingQuantity),
    },
  };
});
